
const HINT_KEY = 'biovet.signed-in';

function storage(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function hasSignInHint(): boolean {
  return storage()?.getItem(HINT_KEY) === '1';
}

export function rememberSignIn(): void {
  try {
    storage()?.setItem(HINT_KEY, '1');
  } catch {
  }
}

export function forgetSignIn(): void {
  try {
    storage()?.removeItem(HINT_KEY);
    storage()?.removeItem('biovet.session.email');
  } catch {
  }
}
